<section class="-mx-screen-w-half px-screen-w-half {{ backgroundColor }}">
	<ng-content></ng-content>
</section>
